import styled from 'styled-components';

import { Color, FontWeight } from '../../enums';
import { StyledComponent } from '../../interfaces';
import { Icon } from '../icon/icon.component';
import { MenuPosition } from '../menuPosition/menuPosition.component';

import { DotProps, StyledMenuPositionProps } from './accountSubmenu.types';

export const Container: StyledComponent<'div'> = styled.div`
  :last-child {
    border-bottom: 1px solid ${Color.Gray300};
  }
`;

export const StyledMenuPositionWrapper: StyledComponent<'div'> = styled.div``;

export const StyledMenuPosition: StyledComponent<typeof MenuPosition, StyledMenuPositionProps>
  = styled(MenuPosition)<StyledMenuPositionProps>`
    display: flex;
    align-items: center;
    padding: 8px 24px 8px 20px;
    min-height: 57px;
    transition: 0.3s;
    justify-content: space-between;
    background-color: ${({ $isActive }: StyledMenuPositionProps): string => $isActive ? Color.Error100 : Color.Transparent};
    color: ${({ $isActive }: StyledMenuPositionProps): string => $isActive ? Color.Error500 : Color.Black};
    border-top: 1px solid ${({ $isActive }: StyledMenuPositionProps): Color => $isActive ? Color.Error300 : Color.Gray300};
  `;

export const StyledMenuPositionLabel: StyledComponent<'div'> = styled.div`
  font-weight: ${FontWeight.Bold};
  font-size: 12px;
  line-height: 16px;
  margin-left: 12px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
`;

export const Dot: StyledComponent<'div', DotProps> = styled.div<DotProps>`
  width: 8px;
  height: 8px;
  background-color: ${({ $color }: DotProps): Color => $color};
  border-radius: 50%;
  flex-shrink: 0;
  margin-left: 5px;
`;

export const IconAndLabelContainer: StyledComponent<'div'> = styled.div`
  display: flex;
  align-items: center;
`;

export const IconContainer: StyledComponent<'div'> = styled.div`
  width: 31px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
`;

export const StyledIcon: StyledComponent<typeof Icon> = styled(Icon)`
  flex-shrink: 0;
`;

export const Image: StyledComponent<'img'> = styled.img`
  border-radius: 50%;
  flex-shrink: 0;
  width: 31px;
  height: 31px;
  object-fit: cover;
`;
